import {
  ALIGNERS_ROTATION_DEVIATION_LIMITS,
  ALIGNERS_TRANSLATION_DEVIATION_LIMITS,
  ARCHES_DEVIATION_LIMITS,
  MONTH_SPEED_LIMITS,
  NEGLIGIBLE_PLAN_LIMIT
} from '../ArchesViewer/archesViewerConsts'
import { TeethTrackingStatuses } from '../txTrackerConsts'

const isFiniteNumber = value => typeof value === 'number' && Number.isFinite(value)

export const getAlignersToothTrackingStatus = toothData => {
  const { translationDeviation, rotationDeviation, deviation } = toothData

  const hasTranslation = isFiniteNumber(translationDeviation)
  const hasRotation = isFiniteNumber(rotationDeviation)
  const hasDeviation = isFiniteNumber(deviation)

  if (!hasTranslation && !hasRotation && !hasDeviation) {
    return TeethTrackingStatuses.TrackingNoMovement
  }

  // NotTracking if ANY metric exceeds its upper threshold
  if (
    (hasTranslation && translationDeviation > ALIGNERS_TRANSLATION_DEVIATION_LIMITS.NOT_TRACKING) ||
    (hasRotation && rotationDeviation > ALIGNERS_ROTATION_DEVIATION_LIMITS.NOT_TRACKING) ||
    (hasDeviation && deviation > ARCHES_DEVIATION_LIMITS.SMALL_OFFSET)
  ) {
    return TeethTrackingStatuses.NotTracking
  }

  // PartiallyTracking if ANY metric exceeds its lower threshold
  if (
    (hasTranslation && translationDeviation > ALIGNERS_TRANSLATION_DEVIATION_LIMITS.SLIGHTLY_OFF_TRACK) ||
    (hasRotation && rotationDeviation > ALIGNERS_ROTATION_DEVIATION_LIMITS.SLIGHTLY_OFF_TRACK) ||
    (hasDeviation && deviation > ARCHES_DEVIATION_LIMITS.MINOR_OFFSET)
  ) {
    return TeethTrackingStatuses.PartiallyTracking
  }

  return TeethTrackingStatuses.Tracking
}

export const getToothTrackingStatus = ({ toothData, treatmentType }) => {
  if (!toothData) {
    return TeethTrackingStatuses.MissingTooth
  }

  const isAlignersTreatment = treatmentType === 'Aligners'

  const { pastMonthSpeed, unknown, low_confidence, no_movement_planned, totalPlannedMovement } = toothData

  if (unknown && !no_movement_planned) {
    return TeethTrackingStatuses.Unknown
  }

  if (isAlignersTreatment) {
    if (!unknown && low_confidence && no_movement_planned) {
      return TeethTrackingStatuses.TrackingNoMovementPlanned
    }

    return getAlignersToothTrackingStatus(toothData)
  }

  if ((unknown && no_movement_planned) || pastMonthSpeed == null) {
    return TeethTrackingStatuses.MissingSpeedInfo
  }

  if (totalPlannedMovement <= NEGLIGIBLE_PLAN_LIMIT) {
    return TeethTrackingStatuses.NegligiblePlan
  }

  if (pastMonthSpeed > MONTH_SPEED_LIMITS.FAST) {
    return TeethTrackingStatuses.Fast
  }

  if (pastMonthSpeed > MONTH_SPEED_LIMITS.MINOR && pastMonthSpeed <= MONTH_SPEED_LIMITS.FAST) {
    return TeethTrackingStatuses.Moderate
  }

  if (pastMonthSpeed > MONTH_SPEED_LIMITS.TINY && pastMonthSpeed <= MONTH_SPEED_LIMITS.MINOR) {
    return TeethTrackingStatuses.Slow
  }

  return TeethTrackingStatuses.NoSignificantMovement
}
